import { HelpIndex, HelpTopicView } from '../../components/help.js';

/**
 * The tenant help center: only topics written for the client audience,
 * served by the portal's own help endpoints.
 */
export function PortalHelpPage() {
  return <HelpIndex shell="portal" />;
}

export function PortalHelpTopicPage() {
  return <HelpTopicView shell="portal" />;
}
